import type { CheckoutCustomer as GQLCheckoutCustomer } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type CheckoutCustomer = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
};

export const fromGQL = (gqlItem: GQLCheckoutCustomer): CheckoutCustomer =>
  take(gqlItem, 'firstName', 'lastName', 'email', 'phoneNumber') as CheckoutCustomer;
